import React from "react";
import { Routes, Route } from "react-router-dom";
import { InvitationPage } from "../../../pages/invitationPage";
import { PublicLayout } from "../../layout/public/PublicLayout";
import { ReadingLayout } from "../../layout/public/session/ReadingLayout";
import { ParticipantDashboard } from "../../participant/Dashboard";
import { ParticipantOnlineSessionPage } from "../../../pages/ParticipantOnlineSessionPage";
import { ParticipantInPersonSessionPage } from "../../../pages/ParticipantInPersonSessionPage";
import { ReadStoryPage } from "../../../pages/ReadStoryPage";
import { ParticipantRoute } from "./ParticipantRoute";
import { ReadAtHomeSurvey } from "../../participant/ReadAtHomeSurvey";
import { SurveyClosePage } from "../../participant/surveyDialog/SurveyClosePage";

const ParticipantRoutes = (): React.ReactElement => {
    return (
        <>
            <Routes>
                <Route
                    path="/participant/survey/close"
                    element={<ParticipantRoute isPublic layout={PublicLayout} component={SurveyClosePage} />}
                />
                <Route
                    path="/invite/:jwt?"
                    element={<ParticipantRoute isPublic layout={PublicLayout} component={InvitationPage} />}
                />
                <Route
                    path="/invite"
                    element={<ParticipantRoute isPublic layout={PublicLayout} component={InvitationPage} />}
                />
                <Route
                    path="/sign-in/:jwt?"
                    element={
                        <ParticipantRoute
                            isPublic
                            layout={PublicLayout}
                            component={() => <InvitationPage isSignIn />}
                        />
                    }
                />
                <Route
                    path="/sign-in"
                    element={
                        <ParticipantRoute
                            isPublic
                            layout={PublicLayout}
                            component={() => <InvitationPage isSignIn />}
                        />
                    }
                />
                <Route
                    path="/participant/dashboard"
                    element={<ParticipantRoute layout={PublicLayout} component={ParticipantDashboard} />}
                />
                <Route
                    path="/participant/:participantId/online-session/:sessionId"
                    element={<ParticipantRoute layout={ReadingLayout} component={ParticipantOnlineSessionPage} />}
                />
                <Route
                    path="/participant/:participantId/session/:sessionId"
                    element={<ParticipantRoute layout={ReadingLayout} component={ParticipantInPersonSessionPage} />}
                />
                <Route
                    path="/read-story/:id/:sessionId?"
                    element={<ParticipantRoute layout={ReadingLayout} component={ReadStoryPage} />}
                />
                <Route
                    path="/read-story/:id"
                    element={<ParticipantRoute layout={ReadingLayout} component={ReadStoryPage} />}
                />
                {/* VER-108: the admin app owns /survey/builder (native survey constructor).
                    This participant block renders in parallel with the admin <Routes> (see App.tsx),
                    and RR v6 would otherwise match /survey/builder against /survey/:id below
                    (:id="builder") → ParticipantRoute → Navigate("/sign-in/"), hijacking the URL
                    away from the admin route. A static passthrough (element={null}) outranks the
                    dynamic /survey/:id within this <Routes>, so the participant side yields the
                    path to the admin app while real participant survey ids still hit /survey/:id. */}
                <Route path="/survey/builder" element={null} />
                {/* VER-109: /survey/results (admin survey-results analytics) must also yield to the
                    admin app — otherwise the dynamic /survey/:id below matches (:id="results") and
                    hijacks it to the participant sign-in. The 3-segment /survey/results/:resultId
                    detail route does not collide with the 2-segment /survey/:id. */}
                <Route path="/survey/results" element={null} />
                <Route
                    path="/survey/:id"
                    element={<ParticipantRoute layout={ReadingLayout} component={ReadAtHomeSurvey} />}
                />
            </Routes>
        </>
    );
};

export default ParticipantRoutes;
